export default {
  EMAIL_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  IS_IMAGE_URL: /\.(jpeg|jpg|gif|png|bmp|svg)$/i,
  POSITIVE_INTEGER_REGEX: /^\d+$/,
  NUMBER_REGEX: /^-?\d+(\.\d+)?$/,
  POSITIVE_NUMBER_REGEX: /^\d+(\.\d+)?$/,
  MAXIMUM_DECIMAL_PLACES_REGEX: /^\d+(\.\d{1,2})?$/,
  JOB_DETAILS_PATH_REGEX: /^\/jobs\/[0-9a-fA-F-]{36}$/,
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  ONE_UPPERCASE_REGEX: /^(?=.*[A-Z]).*$/,
  ONE_LOWERCASE_REGEX: /^(?=.*[a-z]).*$/,
  ONE_NUMBER_REGEX: /^(?=.*\d).*$/,
  ONE_SPECIAL_CHARACTER_REGEX: /^(?=.*[`~!@#$%^&*()_+/\-=[\]{}|\\;:,.<>?'"]).*$/,
  URL_REGEX: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
}
